<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12>
        <table class="v-data-table v-table text-xs-left theme--light">
          <thead>
            <tr>
              <th />

              <th
                v-for="field in fields"
                :key="field.name"
                class="column"
                scope="col"
                :style="{ width: 80 / fields.length + '%' }"
              >
                {{ field.header }}
              </th>

              <th style="width: 20%" class="column" scope="col" />
            </tr>
          </thead>

          <draggable v-model="value.list" tag="tbody" :move="move" @end="saveToSchema">
            <tr v-for="(item, index) in value.list" :key="index">
              <template v-if="editIndex === index">
                <td />

                <td v-for="(field, fieldIndex) in fields" :key="field.name">
                  <v-text-field
                    flat
                    v-model="item[field.name]"
                    :rules="field.required ? Rules : undefined"
                    :autofocus="fieldIndex === 0"
                    :ref="field.name + '_' + index"
                  />
                </td>

                <td class="text-xs-right">
                  <v-btn icon flat color="primary" @click="editValidation(index)">
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>

                  <v-btn icon flat color="error" @click="clearEditing">
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                </td>
              </template>

              <template v-else>
                <td>
                  <v-icon small>mdi-cursor-move</v-icon>
                </td>

                <td v-for="field in fields" :key="field.name">{{ item[field.name] }}</td>

                <td class="text-xs-right">
                  <v-btn icon flat color="primary" @click="editButton(index)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>

                  <v-btn icon flat color="error" @click="deleteItem(index)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td>
              </template>
            </tr>
          </draggable>
        </table>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs10>
        <p class="error--text">{{ schema.$error }}</p>
      </v-flex>

      <v-flex style="padding-top: 1em" xs2>
        <v-btn block color="success" @click="addToList">Dodaj element listy</v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import draggable from 'vuedraggable';

// @vuese
// @group Components/Forms
// Input na listę w formacie JSON
export default {
  props: {
    // JSchema wartości ustawienia
    schema: {
      type: Object,
      required: true
    },
    // Lista pól w formacie `{ name: string, header: string, required?: boolean, copyField?: string }`
    fields: {
      type: Array,
      required: false,
      default: () => [
        { name: 'value', header: 'Wartość', required: true },
        { name: 'text', header: 'Opis', copyField: 'value' }
      ]
    }
  },
  data() {
    return {
      value: {
        type: 'list',
        list: []
      },
      Rules: [val => !!val || 'To pole jest wymagane.'],
      editIndex: undefined
    };
  },
  components: { draggable },
  methods: {
    // @vuese
    // Dodaje wartość do listy
    addToList() {
      const isValid = this.editIndex === undefined || this.editValidation(this.editIndex);
      if (isValid) {
        this.clearEditing();
        this.value.list.push({ value: undefined, text: undefined });
        this.editIndex = this.value.list.length - 1;
      }
    },

    // @vuese
    // Ładuje z modelu do tabelki
    loadList() {
      if (this.schema.$model) {
        const model = JSON.parse(this.schema.$model);
        this.value.list = model.list;
      }
    },
    // @vuese
    // Usuwa wartość na liście
    deleteItem(index) {
      this.clearEditing();
      this.value.list.splice(index, 1);
      this.saveToSchema();
    },
    // @vuese
    // Zamienia JSON na string
    saveToSchema() {
      this.schema.$model = JSON.stringify({ ...this.value });
    },
    // @vuese
    // Ustawia elemnt listy do edycji
    editButton(index) {
      this.clearEditing();
      this.editIndex = index;
    },
    // @vuese
    // Walidacja przy edycji
    editValidation(index) {
      const value = this.value.list[index];
      const invalidFields = this.fields.filter(field => field.required && !value[field.name]);
      this.markFieldsWithErrors(invalidFields, index);
      const isValid = !invalidFields.length;
      if (isValid) {
        this.fields
          .filter(field => !!field.copyField && !value[field.name])
          .forEach(field => (value[field.name] = value[field.copyField]));
        this.editIndex = undefined;
        this.saveToSchema();
      }
      return isValid;
    },
    // @vuese
    // Oznacza błędy na inputach
    markFieldsWithErrors(invalidFields, index) {
      invalidFields
        .map(field => this.$refs[`${field.name}_${index}`])
        .forEach(component => (component[0].error = true));
    },
    // @vuese
    // Sprawdza czy inny obiekt jest w trakcie edycji
    clearEditing() {
      if (this.editIndex !== undefined) {
        this.editIndex = undefined;
        this.loadList();
      }
    },
    // @vuese
    // Blokada move na edycji
    move() {
      return this.editIndex === undefined ? true : false;
    }
  },

  mounted() {
    this.loadList();
  }
};
</script>
